import { inject } from "../../../../../../../lib/itn-ui-kit/services/service-container";

import InjuryDetail from "./InjuryDetail";
import InjuryGraph from "./InjuryGraph";

export default function Injuries({ caseObj }) {
  const currentUserService = inject("current-user-service");
  const permission = "casemanager.view_casereview";
  const canView = currentUserService.userRoles.permissions.includes(permission);

  if (!canView) {
    return <div>You do not have permission to view this content.</div>;
  }

  return (
    <div className="max-h-[85vh] min-h-[60vh] w-full overflow-y-auto">
      <div className="w-full">
        <InjuryDetail caseId={caseObj?.id || ""} />
      </div>
      <div className="mt-4 w-full text-center">
        <InjuryGraph />
      </div>
    </div>
  );
}
